<template>

  <panel-navigation>
    
    <h1 class="text-lg font-semibold mb-3">Turbo Landing Page Settings</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div class="dashboard-box stats-box w-full px-2 -mx-2">
      <v-card
        class="pa-2 h-full"
        tile
      >
        <div v-if="me" :class="'w-full mb-3 p-3'">
            <p class="mb-1 text-xs mb-2"><strong>Call Prompt</strong></p>
            <textarea v-model="me.integrations.turbo_outbound.settings.call_prompt" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 250px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"></textarea>

            <p class="text-xs text-gray-600 pt-2">
                Call prompt.
            </p>

            <v-expansion-panels accordion flat dense>
                <v-expansion-panel>
                    <v-expansion-panel-header>Advanced Options</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Model</strong></p>
                        <select v-model="me.integrations.turbo_outbound.settings.model" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')">
                            <option value="base">Base</option>
                            <option value="enhanced">Enhanced</option>
                            <option value="turbo">Turbo</option>
                            <option value="gpt4">GPT4</option>
                          </select>

                        <p class="text-xs text-gray-600 pt-2">
                          Select a model to use for your call. In nearly all cases, enhanced is the best choice for now.
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Transfer Calls</strong></p>

                        <div class="flex flew-row flex-wrap mb-2 -mx-2">
                          <div class="w-full sm:w-1/4 px-2">
                            <span style="font-size: 12px;">Default:</span><br />
                            <input v-model="me.integrations.turbo_outbound.settings.transfer_list.default" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                              :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                              label=""
                              type="text"
                            />
                          </div>

                          <div class="w-full sm:w-1/4 px-2">
                            <span style="font-size: 12px;">Sales:</span><br />
                            <input v-model="me.integrations.turbo_outbound.settings.transfer_list.sales" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                              :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                              label=""
                              type="text"
                            />
                          </div>

                          <div class="w-full sm:w-1/4 px-2">
                            <span style="font-size: 12px;">Billing:</span><br />
                            <input v-model="me.integrations.turbo_outbound.settings.transfer_list.billing" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                              :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                              label=""
                              type="text"
                            />
                          </div>

                          <div class="w-full sm:w-1/4 px-2">
                            <span style="font-size: 12px;">Support:</span><br />
                            <input v-model="me.integrations.turbo_outbound.settings.transfer_list.support" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                              :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                              label=""
                              type="text"
                            />
                          </div>
                        </div>

                        <!--<a href="javascript: void(0);" style="font-size: 12px;" @click="addDepartment();">Add Department</a>-->

                        <p class="text-xs text-gray-600 pt-2">
                          Give your agent the ability to transfer calls to a human. You can specify a default number and/or add departments.
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Pronunciation Guide</strong></p>

                        <div v-for="(pr_item, pr_index) in me.integrations.turbo_outbound.settings.pronunciation_guide" :key="'pr-guide-' + pr_index">
                          <div class="flex flew-row flex-wrap mb-2 -mx-2">
                            <div class="w-full sm:w-1/4 px-2">
                              <span style="font-size: 12px;">Word:</span><br />
                              <input v-model="pr_item.word" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                label=""
                                type="text"
                              />
                            </div>

                            <div class="w-full sm:w-1/4 px-2">
                              <span style="font-size: 12px;">Pronunciation:</span><br />
                              <input v-model="pr_item.pronunciation" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                label=""
                                type="text"
                              />
                            </div>

                            <div class="w-full sm:w-1/4 px-2">
                              <span style="font-size: 12px;">Case Sensitive:</span><br />
                              <select v-model="pr_item.case_sensitive" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                              :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')">
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>
                            </div>

                            <div class="w-full sm:w-1/4 px-2">
                              <span style="font-size: 12px;">Spaced:</span><br />
                              <select v-model="pr_item.spaced" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                              :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')">
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>
                            </div>

                            <hr class="mt-1 mb-1" />
                          </div>
                        </div>
                        
                        <a href="javascript: void(0);" style="font-size: 12px;" @click="addWord();">Add Word</a>

                        <p class="text-xs text-gray-600 pt-2">
                          The pronunciation guide is a set of instructions of objects that guides the agent on how to say specific words. This is great for situations with complicated terms or names.
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Answered_By Enabled</strong></p>

                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.integrations.turbo_outbound.settings.answered_by_enabled"></v-switch>

                        <p class="text-xs text-gray-600 pt-2">
                          Enables machine detection when the call starts to determine whether the call was answered by a person or a voicemail.
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Reduce Latency</strong></p>
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.integrations.turbo_outbound.settings.reduce_latency"></v-switch>

                        <p class="text-xs text-gray-600 pt-2">
                          Reducing latency means that the agent will generate responses more quickly and have less of a delay.
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Wait For Greeting</strong></p>
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.integrations.turbo_outbound.settings.wait_for_greeting"></v-switch>

                        <p class="text-xs text-gray-600 pt-2">
                          Should the AI speak first or wait for someone else to talk?
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>First Sentence</strong></p>

                        <input v-model="me.integrations.turbo_outbound.settings.first_sentence" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                          type="text"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          A phrase that your call will start with instead of a generating one on the fly. This works both with and without Wait For Greeting. Can be more than one sentence, but must be less than 200 characters.
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Record</strong></p>
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.integrations.turbo_outbound.settings.record"></v-switch>

                        <p class="text-xs text-gray-600 pt-2">
                          To record your phone call, set record to true.
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Language</strong></p>
                        <select v-model="me.integrations.turbo_outbound.settings.language" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')">
                            <option value="eng">ENG</option>
                            <option value="fre">FRE</option>
                            <option value="esp">ESP</option>
                            <option value="pol">POL</option>
                            <option value="pbr">PBR</option>
                          </select>

                        <p class="text-xs text-gray-600 pt-2">
                          Select a supported language of your choice. Available languages: ENG, ESP, FRE, POL, PBR.
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Max Duration</strong></p>
                        <input v-model="me.integrations.turbo_outbound.settings.max_duration" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                          type="number"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          Set the longest you want the call to possibly go in minutes. After the minutes have passed, the call will automatically end.
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Voicemail Action</strong></p>
                        <select v-model="me.integrations.turbo_outbound.settings.voicemail_action" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')">
                            <option value="hangup">Hangup</option>
                            <option value="leave_a_message">Leave A Message</option>
                          </select>

                        <p class="text-xs text-gray-600 pt-2">
                          Voicemail action tells the AI what to do when encountering a voicemail. This has 96% accuracy. There is no such thing as a perfect VM detection, but this gets close.
                        </p>
                      </div>
                      
                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Interruption Threshold</strong></p>
                        <input v-model="me.integrations.turbo_outbound.settings.interruption_threshold" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          When you increase the interruption latency, you force the AI phone agent to listen longer before responding. In practice, increasing the threshold results in less interruptions and more latency.

                          Try setting the threshold to 500 milliseconds. You'll encounter higher latency, but you'll be interrupted much less frequently.
                        </p>
                      </div>
                      

                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Voice ID</strong></p>
                        <select v-model="me.integrations.turbo_outbound.settings.voice" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')">
                            <option value="2">jen-english</option><option value="0">matt</option><option value="4">Cronkite</option><option value="1">sophie-australian</option><option value="5">Basic American woman</option>
                            <option value="2f9fdbc7-4bf2-4792-8a18-21ce3c93978f">maya</option>
                            <option value="37b3f1c8-a01e-4d70-b251-294733f08371">ryan</option>
                            <option value="90295ec4-f0fe-4783-ab33-8b997ddc3ae4">mason</option>
                            <option value="bbeabae6-ec8d-444f-92ad-c8e620d3de8d">tina</option>
                            <option value="e1289219-0ea2-4f22-a994-c542c2a48a0f">Alexa</option>
                            <option value="1d054475-3908-4f64-9158-9d3911fe9597">adriana</option>
                            <option value="a3d43393-dacb-43d3-91d7-b4cb913a5908">matt</option>
                            <option value="ee4c4bb7-08f6-48c5-aaac-bf7a36d3fa51">jen-english</option>
                            <option value="0d6d0300-6aa7-4620-bf2e-297c7deff756">ravi</option>
                            <option value="f5a6b9cd-eba5-4ce6-bfae-9330c466069e">jen-english-5</option>
                            <option value="4154fad2-8aa2-4127-b31b-9cdec04e6696">josh</option>
                            <option value="86812f09-28f0-4538-aa25-5d309e0e6e5d">Florian</option>
                            <option value="642bfa76-18da-4574-857d-4e1a7144db39">helena-spanish-6</option>
                            <option value="f6bd1dee-86e5-43cd-b5e8-f78f820446db">anna-french</option>
                            <option value="fd9c6765-a2ce-429a-abc7-00be9d1e3a92">tanner-british</option>
                            <option value="61507da3-4abd-49b6-983f-9ce659fd9e91">Walter</option>
                            <option value="d0a30fa2-2869-4b8d-9eec-df00dce71157">evelyn</option>
                            <option value="0d6a3160-e7d8-4594-9508-650ec8945ba8">destiny</option>
                            <option value="3e2252e5-ff7d-4b85-8364-9aa09f06563d">diego</option>
                            <option value="60fec350-03ff-48fa-9f31-c180f37b1a38">June</option>
                            <option value="070f5aba-ce9d-4a15-ab68-5330695ed1d6">Jane</option>
                            <option value="2c01ebe7-45d4-4b58-9686-617fa283dd8e">Derek</option>
                            <option value="0f3e6942-5576-4d9d-8437-6c52ed7ed279">Sal</option>
                            <option value="f817dbb3-71fe-4b09-a463-717d0dbb4cf9">Jon</option>
                            <option value="1c1ca816-f457-4dde-a12a-eaf19fb0b523">dave</option>
                            <option value="47c02104-7f23-4857-b1a8-e3e939d56642">ruth</option>
                            <option value="f4c1c16c-29f2-40fc-ba70-b55855572a19">Janis</option>
                            <option value="9d297826-2686-41cb-a0e0-8f6bc55ceaf1">josephine</option>
                            <option value="72254b0f-6e25-4f03-98cc-f2c3bda48602">julia</option>
                            <option value="202ff8ce-0603-45bb-85b4-3549a9360bf8">Marco</option>
                            <option value="e4fa7406-856a-4a8a-99cd-96aa30f7bc32">jessica</option>
                            <option value="6ebcd44e-be55-454a-ba2f-5c156e47d2da">johannes</option>
                            <option value="bb0b519c-c5e0-4275-bbf4-c8f56c08c568">sammie-2051</option>
                            <option value="37f3226e-c92e-4a9a-bfea-6924c249e616">blandie-8</option>
                            <option value="aec18940-3d5a-4454-acd2-66f685e83b67">martha</option>
                            <option value="17a0eab8-d7d5-4304-bb41-7a7b6bda96d3">grace-southern</option>
                            <option value="857ed371-9b28-4006-99da-a28c41c6fa55">sophie-australian</option>
                            <option value="17e8f694-d230-4b64-b040-6108088d9e6c">dorothy-british</option>
                            <option value="ff2c405b-3dba-41e0-9261-bc8ee3f91f46">david</option>
                          </select>

                        <p class="text-xs text-gray-600 pt-2">
                          Select the voice you want to use for this number.
                        </p>
                      </div>

                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Stability</strong></p>
                        <input v-model="me.integrations.turbo_outbound.settings.voice_settings.stability" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                          placeholder="0.8"
                          type="number"
                          step="0.1"
                          min="0.1"
                          max="1"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          Adjust the predictability and consistency of the AI agent's voice. Lower values allow larger deviations from the baseline voice, whether default or cloned. Setting this too high however can cause a monotone voice.
                          <br />
                          Accepts decimal values between 0 and 1 (inclusive).
                        </p>
                      </div>

                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Similarity</strong></p>
                        <input v-model="me.integrations.turbo_outbound.settings.voice_settings.similarity" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                          placeholder="0.8"
                          type="number"
                          step="0.1"
                          min="0.1"
                          max="1"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          Higher values will make speech differences between the selected voice and others more prominent. Extremely high values can cause voice distortion.
                          <br />
                          Use lower values to lower the distinctiveness of the voice or eliminate unwanted audio static spikes.
                          <br />
                          Accepts decimal values between 0 and 1 (inclusive).
                        </p>
                      </div>

                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Speed</strong></p>
                        <input v-model="me.integrations.turbo_outbound.settings.voice_settings.speed" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                          placeholder="0.8"
                          type="number"
                          step="0.1"
                          min="0.1"
                          max="5"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          How fast your agent talks! This parameter is simply a speech-speed multiplier, and works with fractional values such as 0.5 or large ones like 2.
                          <br />
                          Accepts decimal values between 0.1 and 5 (inclusive).
                        </p>
                      </div>

                      <div :class="'w-full mb-3 pt-2'">
                        <p class="mb-1 text-xs mb-2"><strong>Temperature</strong></p>
                        <input v-model="me.integrations.turbo_outbound.settings.temperature" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                          placeholder="0.8"
                          type="number"
                          step="0.1"
                          min="0.1"
                          max="1"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          A value between 0 and 1 that controls the randomness of the LLM. 0 will cause more deterministic outputs while 1 will cause more random.
                        </p>
                      </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

            <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4" :class="{'spinner': sendingCall}" @click="saveTurboOutboundSettings();">
              Save
            </button>
        </div>
      </v-card>
    </div>

  </panel-navigation>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  metaInfo () {
    return {
      title: "Turbo Landing Page Settings | " + this.$appName
    }
  },

  computed: {
    ...mapState({
      me: state => state.me.me,
    })
  },

  components: {
    PanelNavigation
  },

  data () {
    return {
      phone_number: "",
      sendingCall: false
    }
  },

  methods: {
    async saveTurboOutboundSettings() {

      this.sendingCall = true

      let params = { api_key: this.me.integrations.turbo_outbound.settings.api_key };

      params.area_code = this.area_code;

      // if (this.me.integrations.turbo_outbound.settings.phone_number) {
        params.phone_number = this.phone_number;
        params.call_prompt = this.me.integrations.turbo_outbound.settings.call_prompt;
        params.sms_prompt = this.me.integrations.turbo_outbound.settings.sms_prompt;
        params.voice_settings = this.me.integrations.turbo_outbound.settings.voice_settings;
        params.temperature = this.me.integrations.turbo_outbound.settings.temperature;
        params.voice = this.me.integrations.turbo_outbound.settings.voice;

        params.model = this.me.integrations.turbo_outbound.settings.model;
        params.transfer_list = this.me.integrations.turbo_outbound.settings.transfer_list;
        params.pronunciation_guide = this.me.integrations.turbo_outbound.settings.pronunciation_guide;
        params.answered_by_enabled = this.me.integrations.turbo_outbound.settings.answered_by_enabled;
        params.reduce_latency = this.me.integrations.turbo_outbound.settings.reduce_latency;
        params.wait_for_greeting = this.me.integrations.turbo_outbound.settings.wait_for_greeting;
        params.first_sentence = this.me.integrations.turbo_outbound.settings.first_sentence;
        params.record = this.me.integrations.turbo_outbound.settings.record;
        params.language = this.me.integrations.turbo_outbound.settings.language;
        params.max_duration = this.me.integrations.turbo_outbound.settings.max_duration;
        params.voicemail_action = this.me.integrations.turbo_outbound.settings.voicemail_action;
        params.interruption_threshold = this.me.integrations.turbo_outbound.settings.interruption_threshold;
      // }

      await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/save-turbo-outbound-settings`, params, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })
      this.sendingCall = false

        this.$swal({
            title: "Settings saved!",
            text: "The settings for the Turbo landing page have been modified.",
            showCancelButton: false,
        });
    },
  },

  created() {
    
  }
}
</script>